import { router } from 'expo-router';
import React from 'react';
import { useIntl } from 'react-intl';

import { Box, Button, VStack } from '@fhs-legacy/universal-components';
import { useIsDesktopBp } from 'hooks/breakpoints';
import { usePypestreamContext } from 'state/pypestream';
import { focusableLabeledA11yProps } from 'utils/accessibility/focusable-labeled-props';
import { useFlag } from 'utils/launchdarkly';
import { routes } from 'utils/routing';

import { OrderIssuesContainer, OrderIssuesHeading, OrderIssuesText } from './styled';

const OrderIssues: React.FC<React.PropsWithChildren<{ onSupportClick?: VoidFunction }>> = ({
  children,
  onSupportClick,
}) => {
  const { formatMessage } = useIntl();
  const enablePypestream = useFlag('enable-pypestream');
  const { setRedirectToHomePage } = usePypestreamContext();
  const isDesktop = useIsDesktopBp();
  const needHelpHeading = formatMessage({ id: 'needHelp' });
  const issuesBody = formatMessage({ id: 'issuesDuringExperience' });
  const helpAnnouncement = `${needHelpHeading} ${issuesBody}`;

  return (
    <OrderIssuesContainer>
      <Box {...focusableLabeledA11yProps(helpAnnouncement)} flex={1} mr="$1">
        <VStack flex={1} importantForAccessibility="no-hide-descendants">
          <OrderIssuesHeading>{needHelpHeading}</OrderIssuesHeading>
          <OrderIssuesText>{issuesBody}</OrderIssuesText>
          {children}
        </VStack>
      </Box>
      <Button
        variant="outline"
        size="xs"
        onPress={() => {
          /**
           * TODO: When we navigate from cartError to static page, there is no navigation because of that modal
           * appears over staticPage, this callback help us to close the cartError modal in order
           * to make the correct navigation to staticPage. Maybe move away from modal UI to ReactNavigation Modal
           * could help to not use this callback
           */
          onSupportClick?.();
          if (isDesktop && enablePypestream) {
            setRedirectToHomePage(true);
            return router.navigate(routes.base);
          }
          router.navigate(routes.support);
        }}
        _text={{ textTransform: 'capitalize', numberOfLines: 1 }}
      >
        {formatMessage({ id: 'visitSupport' })}
      </Button>
    </OrderIssuesContainer>
  );
};
export default OrderIssues;
